import {
  CondensedHeader,
  Flashy,
  Gutter,
  Icon,
  Layout,
  LayoutItem,
  List,
  ListItem,
  Well,
} from '@axiom/ui';
import React from 'react';

const TopicsCovered = [
  'Timesheet questions & corrections',
  'Expenses including bar dues and practising certificates',
  'Getting access to Practical Law Global or Practising Law Institute',
];

export const SupportContactsModalAxiomAnswers = () => {
  return (
    <div data-test="SUPPORT_CONTACTS_AXIOM_ANSWERS">
      <CondensedHeader>Topics Covered</CondensedHeader>
      <Gutter bottom="8px" />
      <List>
        {TopicsCovered.map((topic, index) => (
          <ListItem key={topic} name={`TOPIC_ITEM_${index}`}>
            <Layout horizontalGutter="16px">
              <LayoutItem>
                <Flashy color="controlSuccessPrimary">
                  <Icon name="circle-check-filled" />
                </Flashy>
              </LayoutItem>
              <LayoutItem fluid>{topic}</LayoutItem>
            </Layout>
          </ListItem>
        ))}
      </List>
      <Gutter bottom="16px" />
      <Well background="light blue">
        <Layout horizontalGutter="16px">
          <LayoutItem>
            <Flashy color="controlActiveSecondary">
              <Icon name="envelope-filled" />
            </Flashy>
          </LayoutItem>
          <LayoutItem fluid>
            <CondensedHeader>Contact Axiom Answers</CondensedHeader>
            <Gutter bottom="8px" />
            <a
              data-test="CONTACT_EMAIL_LINK"
              href="mailto:answers@axiomlaw.com"
            >
              answers@axiomlaw.com
            </a>
          </LayoutItem>
        </Layout>
      </Well>
    </div>
  );
};
